import { useInstantSearch } from 'react-instantsearch';

import { decodeString, stripHtml } from '@libs/common-next';

import type { NoSearchResultProps } from '@/components/NoSearchResult';

import '@/components/NoSearchResult/NoSearchResult.scss';

const NO_RESULT_TEXTS = {
    NO_MATCH: 'We couldn’t find a match for your search.',
    NO_MATCH_FILTERS: 'We couldn’t find a match based on the filters applied.',
    NO_RESULTS: 'No results found',
    REMOVE_FILTER: 'Try removing some filters.',
    HELP_MESSAGE: 'Can’t find what you’re looking for? Contact customer care at ',
    HELP_PHONE: '1-888-839-9638',
};

export default function NoSearchResult({ useFilterMessage }: NoSearchResultProps) {
    const {
        indexUiState: { query },
    } = useInstantSearch();

    // If we have a query, we show the query in the message (?q=QUERY)
    // Otherwise, we show a generic message
    const noQueryMessage = query ? `"${stripHtml(decodeString(query))}"` : NO_RESULT_TEXTS.NO_RESULTS;

    // If we have filters applied, we show a different message
    const noSearchHitMessage = useFilterMessage ? NO_RESULT_TEXTS.NO_MATCH_FILTERS : NO_RESULT_TEXTS.NO_MATCH;

    return (
        <div className="no-search-container error-not-found" data-testid="no-search-result">
            <div className="message-container">
                <p className="no-search-item__query">{noQueryMessage}</p>
                <p className="no-search-item__message">{noSearchHitMessage}</p>
                {useFilterMessage && <p className="no-search-item__message">{NO_RESULT_TEXTS.REMOVE_FILTER}</p>}
            </div>
            <div className="help-message-container">
                <span className="no-search-item__help">{NO_RESULT_TEXTS.HELP_MESSAGE}</span>
                <a href={`tel:${NO_RESULT_TEXTS.HELP_PHONE}`} className="no-search-item__link">
                    {NO_RESULT_TEXTS.HELP_PHONE}.
                </a>
            </div>
        </div>
    );
}
